export const UPDATE_SHOW_DELIVERY_TILE = 'UPDATE_SHOW_DELIVERY_TILE';

type ShowDeliveryTile = boolean;

export const updateShowDeliveryTile = (payload: ShowDeliveryTile) => ({
    type: UPDATE_SHOW_DELIVERY_TILE,
    payload,
});

export default (state = false, action: { type: string; payload: ShowDeliveryTile }) =>
    action.type === UPDATE_SHOW_DELIVERY_TILE ? action.payload : state;
